// tslint:disable-next-line: no-submodule-imports
import merge from 'lodash/merge';
import { BadGatewayError, NotFoundError, ResponseParsingError, ServiceError, } from './error-handling';
import { fetch } from './fetch';
import { createLogger, recordOutgoingMetrics } from './setup';
const logger = createLogger(__filename);
let txId = 0;
function nextTxId() {
    txId++;
    if (txId >= Number.MAX_VALUE) {
        txId = 0;
    }
    return txId;
}
// DEPRECATED
export async function handleJsonResponse(response, service) {
    const status = response.status;
    if (status < 200 || status > 300) {
        switch (status) {
            case 404:
                throw new NotFoundError(status, service, `status ${status} for url ${response.url}`, response);
            case 502:
                throw new BadGatewayError(status, service, `status ${status} for url ${response.url}`, response);
            default:
                throw new ServiceError(status, service, `status ${status} for url ${response.url}`, response);
        }
    }
    else {
        try {
            return await response.json();
        }
        catch (error) {
            throw new ResponseParsingError(status, service, `Parse error <${error.message}> for url ${response.url}`, response);
        }
    }
}
export async function handleJsonResponseWithEmpty(response, service) {
    if (response.status === 204) {
        return null;
    }
    return handleJsonResponse(response, service);
}
export async function callApi(url, serviceName, options = {}, handleResponse = handleJsonResponse) {
    const stopRecordingMetrics = recordOutgoingMetrics(serviceName);
    let response;
    const logFields = { txId: nextTxId() };
    const start = Date.now();
    try {
        logger.info(logFields, 'Start calling %s', url);
        response = await fetch(url, serviceName, options);
    }
    catch (e) {
        logger.error(`Unexpected error for call to service ${serviceName} with url ${url}`, e);
        throw e;
    }
    finally {
        const totalTime = Date.now() - start;
        logger.info(logFields, 'Finished calling %s after %sms', url, totalTime);
        stopRecordingMetrics();
    }
    return handleResponse(response, serviceName);
}
const getMethodDefaults = {
    method: 'GET',
    headers: {
        Accept: 'application/json',
    },
};
export async function getApi(url, serviceName, options = {}, handler) {
    const configuration = merge({}, getMethodDefaults, options);
    return callApi(url, serviceName, configuration, handler);
}
const postMethodDefaults = {
    method: 'POST',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
};
export async function postApi(url, serviceName, body = {}, // tslint:disable-line no-any
options = {}) {
    const configuration = merge({}, postMethodDefaults, { body: JSON.stringify(body) }, options);
    return callApi(url, serviceName, configuration);
}
export async function postFormApi(url, service, body, options = {}) {
    const configuration = merge({}, {
        method: 'POST',
        headers: {
            Accept: 'plain/text',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    }, { body }, options);
    return callApi(url, service, configuration);
}
const postXmlMethodDefaults = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/xml',
    },
};
export async function handleXmlResponse(response, service) {
    const status = response.status;
    try {
        const payload = await response.text();
        return {
            status,
            payload,
        };
    }
    catch (error) {
        throw new ResponseParsingError(status, service, error.message);
    }
}
export async function postXmlApi(url, serviceName, body, options = {}) {
    const configuration = merge({}, postXmlMethodDefaults, { body }, options);
    return callApi(url, serviceName, configuration, handleXmlResponse);
}
